// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"783":"88669ac7","892":"5400f55d","934":"5400f55d"}[chunkId] + ".chunk.css";
};